import React, { useEffect, useState } from 'react'
import './LoanApplication.scss'
import { BreadCrumb, ModalWrapper } from 'Components'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import loanService from './../../../../../Services/loanServices'
import Swal from 'sweetalert2'
import { salaryService } from 'Services/salaryService'
import { CurrencyFormatter } from 'Helpers'

export type loanFormType = {
  amount: 0
  purpose: string
  repaymentDuration: number
  monthlyRepaymentAmount: number
  reason: string
}

const LoanApplication = () => {
  const [request, setRequest] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [show2Modal, setShow2Modal] = useState(false)
  const [repaymentAmount, setRepaymentAmount] = useState(0)

  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<loanFormType>()

  const submit = async (data: loanFormType) => {
    setRequest(true)
    console.log({ ...data })
    await loanService.create({ ...data, monthlyRepaymentAmount: repaymentAmount }).then(
      () => {
        setRequest(false)
        setShow2Modal(true)

        setTimeout(() => {
          navigate('/loan')
        }, 3000)
      },
      (error: { response: { data: { error: string } } }) => {
        console.log('leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  const [loanLimit, setLoanLimit] = useState<number>()

  const getSalary = async () => {
    await salaryService.getEmployeeSalary().then((response) => {
      console.log('getSalary response', response.data.data)

      const earning = response.data.data.earnings
      const deduction = response.data.data.deductions

      const totalEarnings = earning.reduce(
        (sum: number, item: { amount: number }) => sum + item.amount,
        0,
      )

      const totalDeductions = deduction.reduce(
        (sum: number, item: { amount: number }) => sum + item.amount,
        0,
      )

      const loanLimit = (totalEarnings - totalDeductions) * 12 * 0.35
      setLoanLimit(loanLimit)
    })
  }

  useEffect(() => {
    getSalary()
  }, [])

  return (
    <div className='LoanApplication'>
      <div className='container'>
        <BreadCrumb
          title={'Apply for Loan'}
          parent={'Loan'}
          parentUrl={'loan'}
          showTitle={false}
        ></BreadCrumb>
      </div>

      <div className='container mt-5 mb-5'>
        <div className='row justify-content-center'>
          <div className='co-12 col-md-5'>
            <div className='card border-0 px-4 pt-3'>
              <div className='card-header px-0'>Apply for Loan</div>
              <div className='card-body px-0'>
                <form onSubmit={handleSubmit(submit)}>
                  <div className='form-group'>
                    <label>Amount</label>

                    <div className='currency-wrapper'>
                      <span className='currencyAmount'>₦</span>

                      <input
                        type='number'
                        {...register('amount', {
                          required: 'Field is required',
                          min: { value: 1000, message: 'Minimum loan request is 1000' },
                          max: {
                            value: loanLimit ?? 10000,
                            message: `You are not eligible for more than 35% of your annual net salary. Your current limit is ${loanLimit ? CurrencyFormatter(loanLimit) : 0}`,
                          },
                        })}
                        className={`form-control input-with-currency ${errors.amount ? 'is-invalid' : ''}`}
                      />
                    </div>

                    {errors.amount && (
                      <div className='invalid-feedback d-block'>{errors.amount.message}</div>
                    )}
                  </div>
                  {/* {loanLimit && (
                    <div className="text-success fw-bolder loan-limit-value">
                      Loan Limit: ({CurrencyFormatter(loanLimit)})
                    </div>
                  )} */}
                  <div className='form-group mt-3'>
                    <label htmlFor=''>Purpose for loan</label>
                    <input
                      type='text'
                      {...register('purpose', {
                        required: 'Field is required',
                      })}
                      className={`form-control ${errors.purpose ? 'is-invalid' : ''}`}
                    ></input>

                    {errors.purpose && (
                      <div className='invalid-feedback'>{errors.purpose.message}</div>
                    )}
                  </div>
                  <div className='form-group mt-3'>
                    <label htmlFor=''>Repayment Period</label>
                    <select
                      {...register('repaymentDuration', {
                        required: 'Field is required',
                      })}
                      className={`form-control ${errors.repaymentDuration ? 'is-invalid' : ''}`}
                    >
                      <option value={''}>select</option>
                      <option value={12}>12 months</option>
                      <option value={11}>11 months</option>
                      <option value={10}>10 months</option>
                      <option value={9}>9 months</option>
                      <option value={8}>8 months</option>
                      <option value={7}>7 months</option>
                      <option value={6}>6 months</option>
                      <option value={5}>5 months</option>
                      <option value={4}>4 months</option>
                      <option value={3}>3 months</option>
                      <option value={2}>2 months</option>
                      <option value={1}>1 months</option>
                    </select>

                    {errors.repaymentDuration && (
                      <div className='invalid-feedback'>{errors.repaymentDuration.message}</div>
                    )}
                  </div>
                  <div className='form-group mt-3'>
                    <label htmlFor=''>Interest</label>
                    <input type='text' value={'0%'} disabled={true} className={'form-control'} />
                  </div>
                  <div className='form-group mt-3 amount-group'>
                    <label htmlFor=''>Monthly Deduction</label>

                    <div className='currency'>₦</div>
                    <input
                      type='number'
                      {...register('monthlyRepaymentAmount', {
                        // required: "Monthly Repayment amount is required",
                        onChange: (e) => setRepaymentAmount(e.target.value),
                      })}
                      value={
                        watch('amount') && watch('repaymentDuration')
                          ? Number(watch('amount') / watch('repaymentDuration'))
                          : ''
                      }
                      disabled={true}
                      className={`form-control ${
                        errors.monthlyRepaymentAmount ? 'is-invalid' : ''
                      }`}
                    />
                  </div>
                  {errors.monthlyRepaymentAmount && (
                    <div className='invalid-feedback'>{errors.monthlyRepaymentAmount.message}</div>
                  )}

                  <div className='form-group mt-3 d-flex'>
                    <input type='checkbox' className='me-3' required />
                    <label htmlFor=''>
                      {' '}
                      I agree to the{' '}
                      <Link to='' onClick={() => setShowModal(true)} className='text-dark'>
                        Employee Undertaking
                      </Link>{' '}
                      and accept responsibility for repayment.
                    </label>
                  </div>
                  <div className='form-group mt-3'>
                    <button className='btn btn-default w-100' disabled={request}>
                      {request && <span className='spinner-border-spinner-sm'></span>}
                      Apply for Loan
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        title={'Employee Undertaking'}
      >
        <div className='terms-text'>
          <div className='mb-3'>
            I in furtherance of this loan application, do undertake as follows:
          </div>
          <ol>
            <li>
              I acknowledge that my loan application is not as of right and TradeGrid Digital
              Trading Company Limited (“the Company”) reserves the right to refuse my loan
              application either in full or in part.
            </li>
            <li>
              I acknowledge that the loan granted to me by the Company constitutes a debt that I am
              obligated to repay.
            </li>
            <li>
              I authorize the Company to make Approved Monthly Salary Deductions from my salary
              towards repayment of the loan and without any further recourse to me.
            </li>
            <li>
              I undertake to repay the loan in full before I leave the employment of the Company.
            </li>
            <li>
              I understand and authorize that in the event of termination of my employment, any
              benefit(s) that may accrue to me will be applied to repay the loan or any part
              outstanding thereof.
            </li>
            <li>
              I acknowledge that the Company reserves the right to recover the loan or any part
              outstanding thereof through other means permitted by law.
            </li>
          </ol>

          <div className='form-group mt-3 d-flex'>
            <input type='checkbox' className='me-3' required />
            <label htmlFor=''>
              I agree to the loan terms and accept responsibility for repayment.
            </label>
          </div>

          <div className='form-group mt-3 d-flex'>
            <button className='btn btn-default w-100' onClick={() => setShowModal(false)}>
              Go back to application
            </button>
          </div>
        </div>
      </ModalWrapper>

      <ModalWrapper
        showModal={show2Modal}
        closeModal={() => setShow2Modal(false)}
        title={''}
        className='loanSuccessModal'
      >
        <div className='text-center mt-2 mb-4'>
          <svg
            width='96'
            height='95'
            viewBox='0 0 96 95'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='47.8936' cy='47.5' r='46' fill='#F0F0F0' stroke='#D9D9D9' strokeWidth='3' />
            <mask
              id='mask0_2754_3406'
              style={{ maskType: 'alpha' }}
              maskUnits='userSpaceOnUse'
              x='3'
              y='3'
              width='90'
              height='89'
            >
              <circle cx='47.8936' cy='47.5' r='44.5' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_2754_3406)'>
              <path
                d='M83.4038 140.653H11.4995C10.071 140.653 8.89355 139.476 8.89355 138.048V30.4516C8.89355 29.0232 10.071 27.8457 11.4995 27.8457H83.4038C84.8515 27.8457 86.029 29.0232 86.029 30.4516V138.048C86.029 139.476 84.8515 140.653 83.4038 140.653Z'
                fill='#3E4342'
              />
              <path
                d='M14.9354 30.9336H11.5381V137.777L82.844 138.394L84.813 135.943L83.095 35.1417L14.9354 30.9336Z'
                fill='#EBEBEB'
              />
              <path
                d='M84.813 135.943H14.2984V30.9336H11.5381V138.394H82.844L84.813 135.943Z'
                fill='#E0E0E0'
              />
              <path
                d='M90.8934 132.488H21.2283C14.4335 115.597 13.2367 72.6285 14.2984 30.9336H83.481C82.9212 72.6091 84.2724 110.038 90.8934 132.488Z'
                fill='white'
                stroke='white'
                strokeWidth='0.386064'
                strokeMiterlimit='10'
              />
              <path
                opacity='0.2'
                d='M35.0684 27.845V36.0103L60.4713 36.1647L60.4327 34.6591L48.2331 27.459L35.0684 27.845Z'
                fill='black'
              />
              <path
                d='M61.6683 34.659H36.5742V29.061C36.5742 27.4396 37.8868 26.127 39.5276 26.127H58.7343C60.3557 26.127 61.6683 27.4396 61.6683 29.061V34.659Z'
                fill='#3E4342'
              />
              <path
                d='M44.4889 26.8027L43.543 23.5019C43.4658 23.2509 43.6395 23 43.8712 23H55.1056C55.3372 23 55.511 23.2702 55.4338 23.5019L54.3142 26.9765C54.2563 27.1116 54.1211 27.2274 53.9667 27.2274L44.817 27.073C44.6626 27.0537 44.5275 26.9572 44.4889 26.8027Z'
                fill='#3E4342'
              />
              <path
                d='M44.9136 25.9912C48.1565 25.9912 51.4059 25.9912 54.6617 25.9912C55.0284 25.9912 55.0284 25.4121 54.6617 25.4121C51.4059 25.4121 48.1565 25.4121 44.9136 25.4121C44.5275 25.4121 44.5275 25.9912 44.9136 25.9912Z'
                fill='black'
              />
              <path
                d='M41.8936 41.8398H42.9745V44.7932H44.7697V45.6426H41.8936V41.8398Z'
                fill='#407BFF'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M44.9434 43.7502C44.9434 42.6113 45.8313 41.7812 47.0474 41.7812C48.2635 41.7812 49.1514 42.6113 49.1514 43.7502C49.1514 44.8698 48.2635 45.7191 47.0474 45.7191C45.8313 45.7191 44.9434 44.8698 44.9434 43.7502ZM48.0705 43.7502C48.0705 43.0939 47.6265 42.6692 47.0474 42.6692C46.4683 42.6692 46.0243 43.0939 46.0243 43.7502C46.0243 44.4065 46.4683 44.8312 47.0474 44.8312C47.6265 44.8312 48.0705 44.4065 48.0705 43.7502Z'
                fill='#407BFF'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M52.2 44.909H50.5978L50.3083 45.6426H49.208L50.8874 41.8398H51.9298L53.6091 45.6426H52.5089L52.2 44.909ZM51.8718 44.1176L51.3893 42.9015L50.9067 44.1176H51.8718Z'
                fill='#407BFF'
              />
              <path
                d='M57.5286 41.8398V45.6426H56.6407L54.9806 43.6157V45.6426H53.9189V41.8398H54.8069L56.4863 43.8667V41.8398H57.5286Z'
                fill='#407BFF'
              />
              <path
                d='M21.8452 52.7256C27.752 52.7256 33.6652 52.7256 39.5848 52.7256C39.9516 52.7256 39.9709 52.1465 39.5848 52.1465C33.6652 52.1465 27.752 52.1465 21.8452 52.1465C21.4591 52.1465 21.4591 52.7256 21.8452 52.7256Z'
                fill='#E0E0E0'
              />
              <path
                d='M21.8452 56.3935C28.9102 56.3935 35.9816 56.3935 43.0594 56.3935C50.1372 56.3935 57.2086 56.3935 64.2736 56.3935C68.2629 56.3935 72.2522 56.3935 76.2416 56.3935C76.6083 56.3935 76.6083 55.8145 76.2416 55.8145C69.1637 55.8145 62.0923 55.8145 55.0274 55.8145C47.9495 55.8145 40.8717 55.8145 33.7939 55.8145C29.8174 55.8145 25.8345 55.8145 21.8452 55.8145C21.4591 55.8145 21.4591 56.3935 21.8452 56.3935Z'
                fill='#E0E0E0'
              />
              <path
                d='M21.8452 60.042C28.9102 60.042 35.9816 60.042 43.0594 60.042C50.1372 60.042 57.2086 60.042 64.2736 60.042C68.2629 60.042 72.2522 60.042 76.2416 60.042C76.6083 60.042 76.6083 59.4629 76.2416 59.4629C69.1637 59.4629 62.0923 59.4629 55.0274 59.4629C47.9495 59.4629 40.8717 59.4629 33.7939 59.4629C29.8174 59.4629 25.8345 59.4629 21.8452 59.4629C21.4591 59.4629 21.4591 60.042 21.8452 60.042Z'
                fill='#E0E0E0'
              />
              <path
                d='M21.8452 63.6904C28.9102 63.6904 35.9816 63.6904 43.0594 63.6904C50.1372 63.6904 57.2086 63.6904 64.2736 63.6904C68.2629 63.6904 72.2522 63.6904 76.2416 63.6904C76.6083 63.6904 76.6083 63.1113 76.2416 63.1113C69.1637 63.1113 62.0923 63.1113 55.0274 63.1113C47.9495 63.1113 40.8717 63.1113 33.7939 63.1113C29.8174 63.1113 25.8345 63.1113 21.8452 63.1113C21.4591 63.1113 21.4591 63.6904 21.8452 63.6904Z'
                fill='#E0E0E0'
              />
              <path
                d='M21.8462 67.3603C28.9111 67.3603 35.9825 67.3603 43.0604 67.3603C50.1382 67.3603 57.2096 67.3603 64.2746 67.3603C68.2639 67.3603 72.2532 67.3603 76.2425 67.3603C76.6093 67.3603 76.6093 66.7812 76.2425 66.7812C69.1647 66.7812 62.0933 66.7812 55.0283 66.7812C47.9505 66.7812 40.8727 66.7812 33.7949 66.7812C29.8184 66.7812 25.8355 66.7812 21.8462 66.7812C21.4601 66.7812 21.4601 67.3603 21.8462 67.3603Z'
                fill='#E0E0E0'
              />
              <path
                d='M21.8452 71.0029C28.9102 71.0029 35.9816 71.0029 43.0594 71.0029C50.1372 71.0029 57.2086 71.0029 64.2736 71.0029C68.2629 71.0029 72.2522 71.0029 76.2416 71.0029C76.6083 71.0029 76.6083 70.4238 76.2416 70.4238C69.1637 70.4238 62.0923 70.4238 55.0274 70.4238C47.9495 70.4238 40.8717 70.4238 33.7939 70.4238C29.8174 70.4238 25.8345 70.4238 21.8452 70.4238C21.4591 70.4238 21.4591 71.0029 21.8452 71.0029Z'
                fill='#E0E0E0'
              />
              <path
                d='M21.943 75.1357C30.4622 75.1357 38.9749 75.1357 47.4811 75.1357C49.9133 75.1357 52.3455 75.1357 54.7777 75.1357C55.1445 75.1357 55.1445 74.5566 54.7777 74.5566C46.2586 74.5566 37.7459 74.5566 29.2396 74.5566C26.8074 74.5566 24.3752 74.5566 21.943 74.5566C21.5763 74.5566 21.5763 75.1357 21.943 75.1357Z'
                fill='#E0E0E0'
              />
              <path
                d='M21.4792 81.4131C28.6085 81.4131 35.7314 81.4131 42.8478 81.4131C49.9514 81.4131 57.0485 81.4131 64.1392 81.4131C68.1414 81.4131 72.15 81.4131 76.1651 81.4131C76.5318 81.4131 76.5511 80.834 76.1651 80.834C69.0486 80.834 61.9258 80.834 54.7965 80.834C47.7058 80.834 40.6151 80.834 33.5244 80.834C29.5093 80.834 25.4942 80.834 21.4792 80.834C21.1124 80.834 21.1124 81.4131 21.4792 81.4131Z'
                fill='#E0E0E0'
              />
              <path
                d='M22.0591 85.1592C29.1755 85.1592 36.2984 85.1592 43.4277 85.1592C50.5184 85.1592 57.6091 85.1592 64.6998 85.1592C68.7149 85.1592 72.7299 85.1592 76.745 85.1592C77.1117 85.1592 77.1117 84.5801 76.745 84.5801C69.6157 84.5801 62.4864 84.5801 55.3571 84.5801C48.2664 84.5801 41.1757 84.5801 34.085 84.5801C30.0699 84.5801 26.0613 84.5801 22.0591 84.5801C21.673 84.5801 21.673 85.1592 22.0591 85.1592Z'
                fill='#E0E0E0'
              />
              <path
                d='M22.1753 89.0557C29.2917 89.0557 36.4146 89.0557 43.5439 89.0557C50.6346 89.0557 57.7253 89.0557 64.816 89.0557C68.8311 89.0557 72.8461 89.0557 76.8612 89.0557C77.228 89.0557 77.228 88.4766 76.8612 88.4766C69.7319 88.4766 62.609 88.4766 55.4926 88.4766C48.389 88.4766 41.2919 88.4766 34.2012 88.4766C30.199 88.4766 26.1904 88.4766 22.1753 88.4766C21.7892 88.4766 21.7892 89.0557 22.1753 89.0557Z'
                fill='#E0E0E0'
              />
              <path
                d='M58.3688 75.0205C61.4445 75.0205 64.5137 75.0205 67.5764 75.0205C67.9432 75.0205 67.9432 74.4414 67.5764 74.4414C64.5137 74.4414 61.4445 74.4414 58.3688 74.4414C58.0021 74.4414 58.0021 75.0205 58.3688 75.0205Z'
                fill='#E0E0E0'
              />
              <path
                d='M68.6365 47.5348H28.6982V38.9062H68.6365V47.5348Z'
                stroke='#407BFF'
                strokeWidth='0.386064'
                strokeMiterlimit='10'
              />
            </g>
            <path
              d='M74.1085 78.3333C74.0102 78.4663 73.9466 78.6166 73.9119 78.7727L69.766 75.6676L71.2174 73.7363L75.3633 76.8414C75.2187 76.9166 75.0915 77.0207 74.9874 77.1595L74.1085 78.3333Z'
              fill='#8D9995'
            />
            <path
              d='M92.3802 90.1922L91.5013 91.366C91.1312 91.8633 90.4258 91.9673 89.9285 91.5915L74.3336 79.8996C73.9751 79.6336 73.8247 79.1884 73.9114 78.7721C73.9461 78.616 74.0097 78.4656 74.108 78.3326L74.987 77.1588C75.091 77.02 75.2183 76.916 75.3628 76.8408C75.7329 76.6442 76.2012 76.6615 76.5598 76.9333L92.1547 88.6194C92.652 88.9952 92.756 89.6949 92.3802 90.1922Z'
              fill='#484E4C'
            />
            <path
              d='M70.4936 74.702L71.2164 73.7363L75.3623 76.8414C75.2177 76.9166 75.0905 77.0207 74.9865 77.1595L74.547 77.7435L70.1871 74.5574L70.4936 74.702Z'
              fill='#7E8985'
            />
            <path
              d='M74.987 77.1608C75.091 77.022 75.2183 76.9179 75.3628 76.8427C75.7329 76.6461 76.2012 76.6635 76.5598 76.9353L92.1547 88.6213C92.652 88.9972 92.756 89.6968 92.3802 90.1941L91.9003 90.836L74.5475 77.7448L74.987 77.1608Z'
              fill='#3E4342'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M68.7766 57.1888C63.0405 52.8867 54.899 54.049 50.5969 59.7908C46.2949 65.5327 47.4571 73.6684 53.199 77.9704C58.935 82.2725 67.0766 81.1102 71.3786 75.3684C75.6807 69.6323 74.5184 61.4908 68.7766 57.1888ZM68.1116 58.0793C73.3619 62.0112 74.4259 69.4531 70.4939 74.7034C66.5561 79.9538 59.1143 81.0177 53.864 77.0857C48.6136 73.148 47.5497 65.7061 51.4874 60.4558C55.4194 55.2112 62.8612 54.1415 68.1116 58.0793Z'
              fill='#8A999B'
            />
            <path
              opacity='0.3'
              d='M49.5385 70.7426C47.7923 64.4225 51.5045 57.8769 57.8246 56.1307C64.1447 54.3844 70.6903 58.0967 72.4365 64.4167L49.5385 70.7426Z'
              fill='#DCF6FA'
            />
          </svg>

          <div className='text-center mt-4 desc'>
            Loan application is under review, please check back later
          </div>
        </div>
      </ModalWrapper>
    </div>
  )
}

export default LoanApplication
